import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { BookClosureButton } from "../Pages/Bookclosure";

import commoncss from "../../myfin_v2/css/common.module.css";
import bookclosuretaskscss from "../../myfin_v2/css/bookclosuretasks.module.css";
import Modal from "../../myfin_v2/elements/Modal";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import ChooseFromLib from "../../myfin_v2/assets/imgs/choose_from_lib.png";
import AddNewTask from "../../myfin_v2/assets/imgs/add_new_task.png";

export default function CheckFieldDialog({
  isFieldDialog,
  setIsFieldDialog,
  handleTaskCreation,
  onClick,
}) {

  const handleClose = () => {
    setIsFieldDialog(false);
  };

  return (
    <React.Fragment>
      {isFieldDialog && (
        <Modal
          title="Add Task"
          bodycss={commoncss.unsetPadding}
          width="fit-content"
          headerActions={
            <CloseIcon onClick={handleClose} className="clickable" />
          }
        >
          <div
            class={`${commoncss.pdlr15} ${bookclosuretaskscss.taskContainer}`}
          >
            <div
              class={`${commoncss.pdlr15}  ${commoncss.m_tb_20} ${bookclosuretaskscss.taskContainerLeft}`}
            >
              <img
                src={ChooseFromLib}
                alt="Choose from library"
                style={{ width: "300px" }}
                onClick={onClick}
              />
            </div>
            <div
              class={`${commoncss.pdlr15} ${commoncss.m_tb_20} ${bookclosuretaskscss.taskContainerRight}`}
            >
              <img
                src={AddNewTask}
                alt="Add New Task"
                style={{ width: "300px" }}
                onClick={handleTaskCreation}
              />
            </div>
          </div>
        </Modal>
      )}
    </React.Fragment>
  );
}
